export enum IntegrationOmieStatus {
  PENDING = 'PENDENTE',
  SYNCED = 'SINCRONIZADO',
  ERROR = 'ERROR'
}
